import { render, staticRenderFns } from "./AssetSkel.vue?vue&type=template&id=6f0651c2&scoped=true"
import script from "./AssetSkel.vue?vue&type=script&lang=ts"
export * from "./AssetSkel.vue?vue&type=script&lang=ts"
import style0 from "./AssetSkel.vue?vue&type=style&index=0&id=6f0651c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0651c2",
  null
  
)

export default component.exports